import { Link as RouterLink } from 'react-router-dom';

// material-ui
import { Link, Stack, Typography } from '@mui/material';

const Footer = () => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: '24px 16px 0px', mt: 'auto' }}>
    <Typography variant="caption" component={Link} href="https://www.econceptme.com" target="_blank" underline="hover" sx={{ color: 'inherit' }} >&copy; E Concept All rights reserved</Typography>
    <Stack spacing={1.5} direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="caption" color="textPrimary">
        Version No 1.1
      </Typography>
      <Link component={RouterLink} to="#" target="_blank" variant="caption" color="textPrimary" display={'none'}>
        About us
      </Link>
      <Link component={RouterLink} to="#" target="_blank" variant="caption" color="textPrimary" display={'none'}>
        Privacy
      </Link>
      <Link component={RouterLink} to="#" target="_blank" variant="caption" color="textPrimary" display={'none'}>
        Terms
      </Link>
    </Stack>
  </Stack>
);

export default Footer;
